import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AcLineSegmentService } from '../../../../../services/ac-line-segment.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'lib-nec-substation-details-ac-line',
  standalone: false,
  templateUrl: './nec-substation-details-ac-line.component.html',
  styleUrls: ['./nec-substation-details-ac-line.component.scss', '../nec-substation-details.component.scss']
})
export class NecSubstationDetailsAcLineComponent implements OnInit {

  @Input() substationId: any;
  @Output() refreshOverview = new EventEmitter<void>();
  isOpen = false;

  acLineTypes = [
    { id: 1, name: 'Primary Line', type: 'Incoming' },
    { id: 2, name: 'Secondary Line', type: 'Outgoing' }
  ];

  selectedAcLineType: { id: number; name: string; type: string } = this.acLineTypes[0];


  acLineSegments: any[] = []
  acLineSegmentsFilteredByType: any[] = []

  selectedAcLineSegmentId: { value: number | null } | null = { value: 0 };

  modalOpened: boolean = false;

  constructor(private acLineSegmentService: AcLineSegmentService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.getAcLinesBySubstationId(this.substationId);
  }

  toggleHiddenInfo(id: number) {
    if (this.isOpen === false || this.selectedAcLineSegmentId?.value === id || this.selectedAcLineSegmentId?.value === 0)
      this.isOpen = !this.isOpen;
    this.setAcLineSegmentIdValue(id);
  }

  switchAcLineType(acLineType: any) {
    this.selectedAcLineType = acLineType;
    this.acLineSegmentsFilteredByType = this.acLineSegments.filter(x => x.type === acLineType.type);
  }

  getAcLinesBySubstationId(substationId: number): void {
    this.acLineSegmentService.getAcLinesBySubstationId(substationId).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK' && responseData?.data) {
          const data = responseData.data;
          this.acLineSegments = data;
          this.acLineSegmentsFilteredByType = this.acLineSegments.filter(x => x.type === this.selectedAcLineType.type);
        } else {
          this.toastr.error(response.data.message)
        }
      },
      error: () => {
        this.toastr.error('Error occurred while loading AC Line Segment data');
      }
    });
  }

  selectAcLineSegment(acLineSegmentId: number | null) {
    this.isOpen = false;
    this.selectedAcLineSegmentId = { value: acLineSegmentId };
    this.modalOpened = true;
  }

  reloadList() {
    this.selectedAcLineSegmentId = { value: 0 };
    this.getAcLinesBySubstationId(this.substationId);
    this.refreshOverview.emit();
  }

  setAcLineSegmentIdValue(id: number) {
    this.selectedAcLineSegmentId!.value = id;
  }

  newLine() {
    this.isOpen = false;
    this.selectedAcLineSegmentId = { value: 0 };
    this.modalOpened = true;
  }
  updateLine() {
    this.isOpen = false;

    this.modalOpened = true;
  }
}
